module.exports = __webpack_public_path__ + "media/WeChat_20211012163544.6e4ac256.mp4";